class TshirtPersonalizer extends HTMLElement {
  connectedCallback() {
    this.textarea = this.querySelector('textarea');
    this.previewText = this.querySelector('.tshirt-personalizer__text');
    this.previewZone = this.querySelector('.tshirt-personalizer__zone');
    this.counter = this.querySelector('.tshirt-personalizer__counter');
    this.image = this.querySelector('.tshirt-personalizer__image');

    this.maxLines = parseInt(this.dataset.maxLines, 10) || 6;
    this.maxChars = parseInt(this.dataset.maxChars, 10) || 72;
    this.maxLineChars = parseInt(this.dataset.maxLineChars, 10) || 12;
    this.currentLines = [''];
    this.baseFontSize = null;

    if (new URLSearchParams(window.location.search).has('debugzone')) {
      this.previewZone.classList.add('tshirt-personalizer__zone--debug');
    }

    this.textarea.addEventListener('input', this.onInput.bind(this));

    const recompute = () => {
      this.baseFontSize = this.computeBaseFontSize();
      this.applyFontSize();
    };

    new ResizeObserver(recompute).observe(this.previewZone);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recompute);
    }

    if (this.image.complete) {
      recompute();
    } else {
      this.image.addEventListener('load', recompute);
    }

    this.onInput();
  }

  wrap(raw) {
    const lines = [];
    for (const paragraph of raw.split('\n')) {
      let remaining = paragraph;
      while (remaining.length > this.maxLineChars) {
        lines.push(remaining.slice(0, this.maxLineChars));
        remaining = remaining.slice(this.maxLineChars);
      }
      lines.push(remaining);
    }
    return lines.slice(0, this.maxLines).join('\n');
  }

  onInput() {
    const caret = this.textarea.selectionStart;
    const raw = this.textarea.value.toUpperCase();
    const charsBeforeCaret = raw.slice(0, caret).replace(/\n/g, '').length;

    let value = this.wrap(raw);
    if (value.length > this.maxChars) {
      value = value.slice(0, this.maxChars);
    }

    if (value !== this.textarea.value) {
      this.textarea.value = value;

      let seen = 0;
      let newCaret = value.length;
      for (let i = 0; i < value.length; i++) {
        if (value[i] !== '\n') {
          seen++;
        }
        if (seen >= charsBeforeCaret) {
          newCaret = i + 1;
          break;
        }
      }
      this.textarea.setSelectionRange(newCaret, newCaret);
    }

    this.currentLines = value.split('\n');
    this.previewText.textContent = value;
    this.counter.textContent = `${value.replace(/\n/g, '').length}/${this.maxChars}`;
    this.applyFontSize();
  }

  computeBaseFontSize() {
    const zoneHeight = this.previewZone.clientHeight;
    if (!zoneHeight) return null;

    return Math.round(zoneHeight / this.maxLines / 1.05);
  }

  applyFontSize() {
    if (this.baseFontSize) {
      this.previewText.style.fontSize = `${this.baseFontSize}px`;
    }
  }
}

customElements.define('tshirt-personalizer', TshirtPersonalizer);
